module.exports = __webpack_public_path__ + "img/badge-general-knowledge.947ecca8.svg";